import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig, APP_CONFIG } from 'src/app.config';

@Injectable({
    providedIn: 'root',
})
export class CallIntentService {
    lastCustomerIntent: Array<{ category: string; intents: string[] }> = [];
    isIntentLoading = signal(false);

    constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: AppConfig) {}

    getCallIntent(summary: string): Observable<any> {
        const headers = new HttpHeaders({
            'x-api-key': this.config.callSummaryApiKey,
            'Content-Type': 'application/json',
        });
        return this.http.post(this.config.callIntentApi, { summary }, { headers });
    }
}
